import {CobranzaPage} from './CobranzaPage';
export default CobranzaPage;